import { render, staticRenderFns } from "./tree.vue?vue&type=template&id=cfd6dc98&scoped=true"
import script from "./tree.vue?vue&type=script&lang=js"
export * from "./tree.vue?vue&type=script&lang=js"
import style0 from "./tree.vue?vue&type=style&index=0&id=cfd6dc98&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cfd6dc98",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/jenkins/data/workspace/KCC_AUDIT_PROD_Frontend/node_modules/vue-loader/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('cfd6dc98')) {
      api.createRecord('cfd6dc98', component.options)
    } else {
      api.reload('cfd6dc98', component.options)
    }
    module.hot.accept("./tree.vue?vue&type=template&id=cfd6dc98&scoped=true", function () {
      api.rerender('cfd6dc98', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/client-view/matter-logs/tree.vue"
export default component.exports